import { useSetAtom } from "jotai";
import {ConfirmDialogAtom} from "../pages/project/atoms";

const useConfirm = (titleDefault, messageDefault, confirmDefault, cancelDefault, iconDefault) => {
  const setDialog = useSetAtom(ConfirmDialogAtom);

  const confirm = (props) =>
    new Promise((resolve) => {
      const {title, message, confirmText, cancelText, icon} = props || {};
      setDialog({
        open: true,
        title: title || titleDefault || "Are you sure you wan to take this action?",
        message: message || messageDefault || null,
        confirmText: confirmText || confirmDefault || "Confirm",
        cancelText: cancelText || cancelDefault || "Cancel",
        icon: icon || iconDefault || null,
        resolve,
      });
    });

  return confirm;
};

export default useConfirm;
